<script setup lang="ts">
  import {
    Button,
    ButtonType,
    ButtonVariant,
    type ButtonTypeType,
  } from '@tundr/ds-components';
  import { slideoverActionsContainerClass } from './SlideoverActions.css';

  type SlideoverActionsProps = {
    confirmLabel?: string;
    confirmTestId?: string;
    disableConfirm?: boolean;
    cancelLabel?: string;
    cancelTestId?: string;
    disableCancel?: boolean;
    loadingConfirm?: boolean;
    loadingCancel?: boolean;
    confirmDisabledReason?: string;
    confirmType?: ButtonTypeType;
  };

  defineProps<SlideoverActionsProps>();

  const emits = defineEmits<{
    confirm: [];
    cancel: [];
  }>();
</script>

<template>
  <div :class="slideoverActionsContainerClass">
    <Button
      v-if="cancelLabel"
      :test-id="cancelTestId || 'cancel-slideover-button'"
      :variant="ButtonVariant.Text"
      :disabled="disableCancel"
      :loading="loadingCancel"
      @click="emits('cancel')"
      >{{ cancelLabel }}
    </Button>
    <Button
      v-if="confirmLabel"
      :test-id="confirmTestId || 'confirm-slideover-button'"
      :variant="ButtonVariant.Primary"
      :type="confirmType || ButtonType.Button"
      :disabled="disableConfirm"
      :loading="loadingConfirm"
      :disabled-reason="confirmDisabledReason"
      @click="emits('confirm')"
      >{{ confirmLabel }}
    </Button>
  </div>
</template>
